import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {
  Alert,
  AlertIcon,
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Grid,
  GridItem,
  Icon,
  Link,
  useDisclosure,
} from '@chakra-ui/react';
import { IoMenu } from 'react-icons/io5';
import NavigationBar from './Navigation/NavigationBar';
import { useAuth } from '../Context/AuthContext';

import { extendTheme } from '@chakra-ui/react';
const theme = extendTheme({
  components: {
    Drawer: {
      parts: ['dialog', 'header', 'body'],
      variants: {
        primary: {
          secondary: {
            dialog: {
              maxW: '220px',
            },
          },
        },
      },
    },
  },
});

export default function PrivateRoute({ component: Component, ...rest }) {
  const { currentUser } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Grid
      templateColumns="repeat(6, 1fr)"
      bg="#FFFFFF"
      overflowY="auto"
      sx={{
        '&::-webkit-scrollbar': {
          width: '10px', // Width of the scrollbar
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888', // Color of the scrollbar handle
          borderRadius: '5px', // Rounded corners
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#f1f1f1', // Color of the scrollbar track
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#555', // Darker color when hovered
        },
      }}
    >
      <GridItem
        colSpan={{ xl: 0 }}
        display={{ base: 'block', xl: 'none' }}
        position={{ base: 'fixed', lg: 'fixed' }}
        // pos="fixed"
        //width="300px"
      >
        <Box m="15px">
          <Icon
            as={IoMenu}
            width="35px"
            height="35px"
            color="inherit"
            cursor="pointer"
            onClick={onOpen}
          />
        </Box>
        <Drawer
          isOpen={isOpen}
          placement="left"
          onClose={onClose}
          //variant="secondary"
          //size={2}
          // finalFocusRef={btnRef}
          size={'xs'}
          //maxW = {"200px"}
          // bg='yellow.400'
          bg="#FFFFFF"
          //width="300px"
        >
          <DrawerOverlay display={{ base: 'flex', xl: 'none' }} />
          <DrawerContent display={{ base: 'flex', xl: 'none' }}>
            <DrawerCloseButton />
            {/* <DrawerHeader>Create your account</DrawerHeader> */}

            <DrawerBody>
              <NavigationBar onClose={onClose} />
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </GridItem>
      <GridItem
        colSpan={{ base: 0, xl: 1 }}
        pos="relative"
        display={{ base: 'none', xl: 'block' }}
      >
        <Box
          bg="white"
          minH="100%"
          w="100%"
          pos="absolute"
          boxShadow="14px 17px 40px 4px rgba(112, 144, 176, 0.08)"
        >
          <NavigationBar />
        </Box>
      </GridItem>

      <GridItem colSpan={{ base: 6, xl: 5 }} minHeight="100vh" p="0px 16px">
        <Route
          {...rest}
          render={props => {
            return currentUser ? (
              <Component {...props} />
            ) : (
              <Redirect to="/login" />
            );
          }}
        ></Route>
      </GridItem>
    </Grid>
  );
}
